import React, { Fragment } from 'react'
import { Row, Image, Table, Col, Divider, Typography } from 'antd'
import { prUrl } from '../config';
import { cordConvert } from '../../utils'
import '../../App.css'

const { Title } = Typography;

const infoBoxCcolumns = [
    {
        title: '属性项',
        dataIndex: 'label',
        key: 'label',
        width: '30%',
        align: 'center',
    },
    {
        title: '属性值',
        dataIndex: 'value',
        key: 'value',
    },
]

const setTableData = (tableData) => {
    var data = []
    for (var i in tableData) {
        if (tableData[i].value) {
            data.push(tableData[i])
        }
    }
    return data
}

const TargetInfoBox = (props) => {
    const { chnName, engName, description, type, locCountry, opCountry, location, lat, lon, image, qcode, screenName, encryptedWiki } = props.target
    var tabledaData = [
        { key: '1', label: '中文名', value: chnName },
        { key: '2', label: '英文名 ', value: engName },
        { key: '3', label: '类型', value: type },
        { key: '4', label: '驻在国', value: locCountry },
        { key: '5', label: '所属国', value: opCountry },
        { key: '6', label: '位置', value: location },
        { key: '7', label: '经纬度', value: cordConvert(lat, lon) },
        { key: '8', label: 'twitter', value: screenName ? "https://twitter.com/" + screenName : '' },
    ]
    return (
        <Row align='middle' justify='center'>
            <Divider orientation="left" ><Title align="left" level={4}>
                {encryptedWiki ? <a href={prUrl + encryptedWiki} target="blank">{chnName ? chnName : engName}</a> : ''}</Title></Divider>
            <Col span={16} >
                <Row align='middle' justify='center'>
                    {image ? <Image src={prUrl + image} preview={false} height={'40vh'} /> : <Image src='./tent2.png' preview={false} />}
                </Row>
                <Row align='middle' justify='center'>
                    {
                        (description || props.wikiIntro) ?
                            <Fragment>
                                <Divider orientation="left" ><Title align="left" level={4}>简介</Title></Divider>
                                {description ? <p style={{ "text-indent": "50px", fontSize: '16px' }} >{description}</p> :
                                    <p style={{ "text-indent": "50px", fontSize: '16px' }} >{props.wikiIntro}</p>}
                            </Fragment>
                            : ''
                    }
                </Row>
            </Col>
            <Col span={6} offset={1}>
                {
                    qcode ? (props.infoboxhtml ?
                        <Row Row align='middle' justify='center'>
                            <table class="infoboxVcard" cellspacing="3" style={{ width: "50em", textAlign: "center" }} dangerouslySetInnerHTML={{ __html: props.infoboxhtml }}></table>
                        </Row> : '')
                        : <Table columns={infoBoxCcolumns} showHeader={false}
                            dataSource={setTableData(tabledaData)}
                            size="small" pagination={{ hideOnSinglePage: true }}></Table>
                }
            </Col>

        </Row>

    )
}

export default TargetInfoBox;